"use strict";
/*
 * Created on 04 12 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutReleaseItemSupplyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemSupplyConverter, _DataObjectConverter_);

  function SelloutReleaseItemSupplyConverter() {
    _classCallCheck(this, SelloutReleaseItemSupplyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupplyConverter).apply(this, arguments));
  }

  return SelloutReleaseItemSupplyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemSupplyConverter = SelloutReleaseItemSupplyConverter;